import React, { useEffect } from 'react';

const TABOOLA_LOADER_ID = 'tb_loader_script';
const TABOOLA_SRC = '//cdn.taboola.com/libtrc/latestfootballmedia/loader.js';
const DEFAULT_DELAY_MS = 0;

const ensureTaboolaLoader = () => {
  if (document.getElementById(TABOOLA_LOADER_ID)) return;
  const script = document.createElement('script');
  script.async = true;
  script.src = TABOOLA_SRC;
  script.id = TABOOLA_LOADER_ID;
  const target = document.getElementsByTagName('script')[0] || document.head;
  if (target && target.parentNode) {
    target.parentNode.insertBefore(script, target);
  } else {
    document.head.appendChild(script);
  }
};

const pushTaboola = ({ mode, containerId, placement }) => {
  window._taboola = window._taboola || [];
  if (!window.__taboolaArticleConfigured) {
    window._taboola.push({ article: 'auto' });
    window.__taboolaArticleConfigured = true;
  }
  window._taboola.push({
    mode,
    container: containerId,
    placement,
    target_type: 'mix',
    article: 'auto',
  });
  window._taboola.push({ flush: true });
};

const AdComponent = ({
  containerId = 'taboola-mid-article-thumbnails',
  mode = 'thumbnails-mid',
  placement = 'Mid Article Thumbnails',
  delayMs = DEFAULT_DELAY_MS,
}) => {
  useEffect(() => {
    ensureTaboolaLoader();
    let retries = 0;
    let retryTimer = null;
    let delayTimer = null;
    const maxRetries = 3;

    const requestAd = () => {
      pushTaboola({ mode, containerId, placement });
      const container = document.getElementById(containerId);
      const hasContent = container && container.children && container.children.length > 0;
      if (!hasContent && retries < maxRetries) {
        retries += 1;
        retryTimer = setTimeout(requestAd, 1500);
      }
    };

    delayTimer = setTimeout(() => {
      requestAnimationFrame(requestAd);
    }, delayMs);
    return () => {
      if (retryTimer) clearTimeout(retryTimer);
      if (delayTimer) clearTimeout(delayTimer);
    };
  }, [containerId, mode, placement, delayMs]);

  return <div id={containerId}></div>;
};

export default AdComponent;
